"use strict";

const RegexRule = require('bunsen/validation/deprecated/rules/RegexRule');
const RegexFieldValidation = require('bunsen/validation/deprecated/field-validations/RegexFieldValidation.js');
const FinancialAmount = require('bunsen/models/FinancialAmount');
const regexRules = require('bunsen/validation/deprecated/helpers/common-rules');
const pick = require('lodash.pick');

/**
 * @class LocalizedCurrencyValidation
 * @extends RegexFieldValidation
 */
const LocalizedCurrencyValidation = module.exports = RegexFieldValidation.extend({
    initialize: function (options) {
        options = options || {};
        const isEur = options.currency === FinancialAmount.CURRENCY_EUR;
        this.regex = isEur ? regexRules.currencyStringEur : regexRules.currencyString;
        this.rule = new RegexRule(pick(this, 'regex', 'noMatch', 'message'));
        if (typeof options.getModelValueForField === 'function') {
            this.getModelValueForField = options.getModelValueForField;
        }
        LocalizedCurrencyValidation.__super__.initialize.call(this, options);
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/validation/deprecated/field-validations/LocalizedCurrencyValidation.es.js